'use strict';
import {module} from "../app";

module
  .directive("dropdown", function ($rootScope) {
    return {
      restrict: "E",
      templateUrl: "views/templates/dropdown.html",
      scope: {
        placeholder: "@",
        list: "=",
        selected: "=",
        property: "@",
        key: "@"
      },
      link: function (scope) {
        scope.listVisible = false;
        scope.isPlaceholder = true;

        scope.select = function (item) {
          if (item.separator) {
            return;
          }
          scope.isPlaceholder = false;
          scope.selected = item[scope.key];
          if (scope.onChange !== undefined)
            scope.onChange(item);
        };

        scope.isSelected = function (item) {
          return item[scope.key] === scope.selected;
        };

        scope.show = function () {
          scope.listVisible = true;
        };

        scope.$on("documentClicked", function (inner, target) {
          if (!$(target[0]).is(".dropdown-display.clicked") && !$(target[0]).parents(".dropdown-display.clicked").length > 0)
            scope.$apply(function () {
              scope.listVisible = false;
            });
        });

        scope.$watch("selected", function (value) {
          let selectedItem = scope.list.find((item) => item[scope.key] === scope.selected);
          scope.isPlaceholder = !selectedItem;
          scope.display = selectedItem ? selectedItem[scope.property] : null;
        });
      }
    }
  });



// WEBPACK FOOTER //
// ./src/scripts/directives/dropdown.js